class ComparisonDiagram {
    constructor(elem) {
        this.elem = elem;
        this.controlsWrap = this.elem.querySelector(".js-comparison-diagram-tabs");
        this.controls = this.elem.querySelectorAll("[data-diagramm]");
        this.slides = this.elem.querySelectorAll(".js-comparison-diagram-slide");
        this.maxValue = this.elem.querySelector(".js-comparison-diagram-swiper-max-value");

        this._init();
    }

    _init() {
        this._initDiagramm();

        if (window.mobileMedia) {
            this._initCustomSelect();
        } else {
            this._initControlsListeners();
        }
    }

    _initDiagramm() {
        this.controls[0].classList.add("active");
        this._fillSlides(this.controls[0].getAttribute(["data-diagramm"]));
    }

    _initControlsListeners() {
        this.controls.forEach((control) => {
            control.addEventListener("click", () => {
                const filterType = control.getAttribute(["data-diagramm"]);
                this._fillSlides(filterType);

                this.controls.forEach((control) => {
                    control.classList.remove("active");
                });
                control.classList.add("active");
            });
        });
    }

    _fillSlides(type) {
        let maxValueNum = 0;
        let maxValueString = "";

        this.slides.forEach((slide) => {
            const slideData = slide.querySelector(`[data-diagramm-slide="${type}"]`);

            slide.querySelectorAll("[data-diagramm-slide]").forEach((slide) => {
                slide.classList.add("hidden");
            });
            slideData.classList.remove("hidden");

            const clearSlideData = slideData.innerHTML.replace(/\D/g, "");

            if (+clearSlideData > maxValueNum) {
                maxValueNum = +clearSlideData;
                maxValueString = slideData.innerHTML;
            }
        });

        this.slides.forEach((slide) => {
            const dataDiagrammSlide = slide.querySelector(`[data-diagramm-slide="${type}"]`).innerHTML;
            const slideValue = +dataDiagrammSlide.replace(/\D/g, "");

            slide.style.height = `${(slideValue / maxValueNum) * 100}%`;
        });

        this.maxValue.innerHTML = maxValueString;
    }

    _initCustomSelect() {
        this.controlsWrap.addEventListener("click", () => {
            this.controlsWrap.classList.toggle("active");
            this._initControlsListeners();

            document.addEventListener("click", (e) => {
                if (!e.target.closest(".js-comparison-diagram-tabs")) {
                    this.controlsWrap.classList.remove("active");
                }
            });
        });
    }
}

const comparisonDiagram = document.querySelector(".js-comparison-diagram-init");

if (comparisonDiagram) {
    window.addEventListener("load", () => new ComparisonDiagram(comparisonDiagram));
}
